/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IMoeSearchResultContainer containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum expandRefinersCount {
    all = 'all',
    one = 'one',
    two = 'two',
    three = 'three',
    four = 'four'
}

export const enum siteName {
    och = 'och',
    nzc = 'nzc',
    twk = 'twk',
    kwr = 'kwr',
    koh = 'koh'
}

export interface IMoeSearchResultContainerConfig extends Msdyn365.IModuleConfig {
    itemsPerPage: number;
    allowBackNavigation?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    expandRefinersCount?: expandRefinersCount;
    disableHierarchy?: boolean;
    includeAttributes?: boolean;
    enableAffiliationBasedPricing?: boolean;
    updateRefinerPanel?: boolean;
    className?: string;
    learningAreaName?: string;
    siteName: siteName;
    searchTextBoxName?: string;
    domainData?: string;
    ochSearch?: boolean;
    nzcSearchUrl?: string;
    twkSearchUrl?: string;
    kohSearchUrl?: string;
    kwrSearchUrl?: string;
}

export interface IMoeSearchResultContainerResources {
    noResultsForRefinersText: string;
    noResultsForRefinersTextInMaori: string;
    resultCategoryNotFoundText: string;
    resultCategoryNotFoundTextInMaori: string;
    resultSearchNotFoundText: string;
    resultSearchNotFoundTextInMaori: string;
    paginationAriaLabel: string;
    paginationAriaLabelInMaori: string;
    priceFree: string;
    priceFreeInMaori: string;
    priceRangeSeparator: string;
    priceRangeSeparatorInMaori: string;
    originalPriceText: string;
    originalPriceTextInMaori: string;
    currentPriceText: string;
    currentPriceTextInMaori: string;
    ratingAriaLabel: string;
    ratingAriaLabelInMaori: string;
    flipperNext: string;
    flipperNextInMaori: string;
    flipperPrevious: string;
    flipperPreviousInMaori: string;
    searchTextPrefix: string;
    searchTextPrefixInMaori: string;
    numberOfProducts: string;
    numberOfProductsInMaori: string;
    oneProduct: string;
    oneProductInMaori: string;
    categoryLinkAriaLabel: string;
    categoryLinkAriaLabelInMaori: string;
    sortByDropdownLabel: string;
    sortByDropdownLabelInMaori: string;
    sortByOptionNameAsc: string;
    sortByOptionNameAscInMaori: string;
    sortByOptionNameDesc: string;
    sortByOptionNameDescInMaori: string;
    sortByOptionPriceAsc: string;
    sortByOptionPriceAscInMaori: string;
    sortByOptionPriceDesc: string;
    sortByOptionPriceDescInMaori: string;
    sortByOptionRatingDesc: string;
    sortByOptionRatingDescInMaori: string;
    sortByOptionBestSelling: string;
    sortByOptionBestSellingInMaori: string;
    sortByOptionNewScore: string;
    sortByOptionNewScoreInMaori: string;
    sortByOptionTrendingScore: string;
    sortByOptionTrendingScoreInMaori: string;
    sortByOptionRelevanceDesc: string;
    sortByOptionRelevanceDescInMaori: string;
    placeholderTextMax: string;
    placeholderTextMaxInMaori: string;
    minLabel: string;
    minLabelInMaori: string;
    maxLabel: string;
    maxLabelInMaori: string;
    rangeNameFormat: string;
    rangeNameFormatInMaori: string;
    validationErrorNotNumber: string;
    validationErrorNotNumberInMaori: string;
    validationErrorNotRange: string;
    validationErrorNotRangeInMaori: string;
    clearAllText: string;
    clearAllTextInMaori: string;
    choiceSummaryLabel: string;
    choiceSummaryLabelInMaori: string;
    choiceFormat: string;
    choiceFormatInMaori: string;
    choiceRangeValueFormat: string;
    choiceRangeValueFormatInMaori: string;
    choiceAriaLabel: string;
    choiceAriaLabelInMaori: string;
    closeAriaLabel: string;
    closeAriaLabelInMaori: string;
    modalTitle: string;
    modalTitleInMaori: string;
    modalCloseButtonText: string;
    modalCloseButtonTextInMaori: string;
    minValueSliderThumbAriaLabel: string;
    minValueSliderThumbAriaLabelInMaori: string;
    maxValueSliderThumbAriaLabel: string;
    maxValueSliderThumbAriaLabelInMaori: string;
    featureSimilarLooksTitle: string;
    featureSimilarLooksTitleInMaori: string;
    featureSimilarDescriptionTitle: string;
    featureSimilarDescriptionTitleInMaori: string;
    productCountAriaLabel: string;
    productCountAriaLabelInMaori: string;
    singleProductCountAriaLabel: string;
    singleProductCountAriaLabelInMaori: string;
    listViewButtonText: string;
    listViewButtonTextInMaori: string;
    tileViewButtonText: string;
    tileViewButtonTextInMaori: string;
    showMoreText: string;
    showMoreTextInMaori: string;
    filterText: string;
    filterTextInMaori: string;
    externalSitesTabText: string;
    externalSitesTabTextInMaori: string;
    artifactsTabText: string;
    artifactsTabTextInMaori: string;
    ochTabText: string;
    ochTabTextInMaori: string;
    resourcesTabText: string;
    resourcesTabTextInMaori: string;
    curatedCollectionTabText: string;
    curatedCollectionTabTextInMaori: string;
    expandAllText: string;
    expandAllTextInMaori: string;
    collapseAllText: string;
    collapseAllTextInMaori: string;
    ochSearchResultsText: string;
    ochSearchResultsTextInMaori: string;
    clickFiltersText: string;
    clickFiltersTextInMaori: string;
}

export interface IMoeSearchResultContainerProps<T> extends Msdyn365.IModule<T> {
    resources: IMoeSearchResultContainerResources;
    config: IMoeSearchResultContainerConfig;
    slots: {
        quickview: React.ReactNode[];
    };
}
